<script>
    import { createUserAccount } from '/public/services/users/users';
    import { slide } from 'svelte/transition';    
    import { Eye, EyeSlash } from "svelte-bootstrap-icons";
    import PasswordComplexity from '/core/components/users/PasswordComplexity.svelte';


	let member = {
		first_name: null,
		last_name: null,
		email: null,
		password: '',
        password_confirmation: ''
	}

    let showPassword = false;
    let passwordOK = false;
    

    function createAccount(e) {
        e.preventDefault();
                   
        member.password;
        member.password_confirmation = member.password;

        createUserAccount(member).then(res => {
            if (res.success === true) {
                window.location = '/me';
            }
        });
    }

    function passwordComplexityEvent(evt) {
       
        passwordOK = evt.detail;
    }
       
</script>

<form on:submit={createAccount} in:slide>    
    <div class="mb-3 form-floating">       
        <input 
            id="first-name" 
            type="text" 
            class="form-control" 
            required 
            bind:value={member.first_name}                     
        />       
        <label for="first-name" class=''>
            First name
        </label>
    </div>
    <div class="mb-3 form-floating">        
        <input 
            id="last-name" 
            type="text" 
            class="form-control" 
            required 
            bind:value={member.last_name}                       
        />        
        <label for="last-name" class=''>
            Last name
        </label>
    </div>
    <div class="mb-3 form-floating">        
        <input 
            id="email" 
            type="email" 
            class="form-control" 
            required 
            bind:value={member.email}                         
        />       
        <label for="email" class=''>
            Email
        </label> 
    </div>
    <div class='mb-3'>         
        <div class="input-group">
                  
            <div class='form-floating'>

                {#if showPassword === false}

                    <input 
                        type='password'
                        id="password" 
                        class="form-control" 
                        required 
                        bind:value={member.password}                                        
                    />

                {:else}

                    <input 
                        type='text'
                        id="password" 
                        class="form-control" 
                        required 
                        bind:value={member.password}                                       
                    />

                {/if}    

                <label for="password" class=''>
                    Password
                </label>

            </div>
            
            <span class='input-group-text'>
                <span 
                    class='js-button fas'                
                    on:click={() => showPassword = ! showPassword}
                    on:keypress={() => showPassword = ! showPassword}
                    role='button'
                    tabindex='0'
                >

                    {#if showPassword === false}

                        <Eye/>

                    {:else}

                        <EyeSlash/>

                    {/if}

                </span>
            </span>             
        </div>       
        
    </div>  

    <div class='text-center mb-3'>
        <small>

            {#key member.password}

                <PasswordComplexity
                    password={member.password}
                    on:complexity={passwordComplexityEvent}
                />

            {/key}

        </small>

    </div>

    <div class='mb-3'>
        <div class='d-grid'>
            <button type="submit" class="btn btn-primary btn-lg text-white" disabled={passwordOK === false}>
                
                Continue
                
            </button>
        </div>
    </div>    
</form>